import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatMoney } from "@/lib/api";
import { Progress } from "@/components/ui/progress";

export default function Fundraisers() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/fundraisers").then(({ data }) => setItems(data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-6 py-10" data-testid="fundraisers-page">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-900">Family Fundraisers</h1>
          <p className="text-slate-600 mt-2">Help fund AAC tablets, sensory rooms, and life-changing tools.</p>
        </div>
        <Link to="/fundraisers/new" data-testid="start-fundraiser-link" className="btn-pink">Start a Fundraiser</Link>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-6">
        {items.map((f) => {
          const pct = Math.min(100, (f.raised / f.goal_amount) * 100);
          return (
            <Link key={f.fundraiser_id} to={`/fundraisers/${f.fundraiser_id}`} data-testid={`fundraiser-${f.fundraiser_id}`} className="card-soft overflow-hidden">
              <img src={f.image_url} alt={f.title} className="w-full aspect-[4/3] object-cover" />
              <div className="p-5">
                <div className="text-xs font-bold uppercase tracking-wider text-purple-600">{f.category}</div>
                <h3 className="font-display font-bold text-lg text-slate-900 mt-1">{f.title}</h3>
                <p className="text-sm text-slate-600 mt-1">by {f.organizer_name}</p>
                <Progress value={pct} className="mt-4" />
                <div className="flex justify-between mt-2 text-sm">
                  <span className="font-bold text-pink-600">{formatMoney(f.raised)} raised</span>
                  <span className="text-slate-500">of {formatMoney(f.goal_amount)}</span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
